import { httpGetAsync, httpPost } from "../../utilities/TZMRequest";

export class ConfiguracaoService     {

    completar = async () => {
        return await httpGetAsync("/configuracoes-fiscal-pedido/completar");
    } 

	salvar(configuracaoFiscalPedido) {
		return httpPost("/configuracoes-fiscal-pedido", configuracaoFiscalPedido);
	}

    listarCodigosTributarios = async (params) => {
        return  httpGetAsync("/configuracoes-fiscal-pedido/listar-codigos-tributario", params, true);
	}

    listarCfops = async (params) => {
        return  httpGetAsync("/configuracoes-fiscal-pedido/listar-cfops", params, true);
	}

    listarTiposMovimento = async (params) => {
        return  httpGetAsync("/configuracoes-fiscal-pedido/listar-tipos-movimento", params, true);
	}
}